import { DocumentNode } from "@apollo/client"

import { FloorDocument } from "entities/floors/graphql/queries.generated"
import { ProductPositionDocument } from "entities/product-positions/graphql/queries.generated"
import { ProjectChildrenDocument } from "entities/projects/graphql/queries.generated"
import { RoomDocument } from "entities/rooms/graphql/queries.generated"

import { ClarificationRequestResourceType } from "../types/ClarificationRequest"

const queryDocumentByResourceType: Record<
  ClarificationRequestResourceType,
  DocumentNode
> = {
  projects: ProjectChildrenDocument,
  floors: FloorDocument,
  rooms: RoomDocument,
  "project-positions": ProductPositionDocument
}

export function getQueryDocumentByResourceType(
  resourceType: ClarificationRequestResourceType
): DocumentNode {
  return queryDocumentByResourceType[resourceType]
}
